module.exports = __webpack_public_path__ + "static/media/gatsby-svg-blur.ba466ba1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/slides/05-why-gatsby/video/gatsby-svg-blur.mp4
// module id = 953
// module chunks = 0